/**
 * Created by CCristi <ccovali@mitocgroup.com> on 4/19/16.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EventFactory = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _FrameworkEvent = require('./FrameworkEvent');

var _FrontendEvent = require('./FrontendEvent');

var _AbstractEvent = require('./AbstractEvent');

var _UnknownRumEventException = require('../Exception/UnknownRumEventException');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Event Factory
 */
let EventFactory = exports.EventFactory = function () {
  function EventFactory() {
    _classCallCheck(this, EventFactory);
  }

  _createClass(EventFactory, null, [{
    key: 'create',

    /**
     * @param {Object} kernel
     * @param {Object} rawData
     * @returns {EventClass}
     */
    value: function create(kernel, rawData) {
      let EventClass = null;

      // @note - For the time being event type is guessed by event.service
      // (it'll be changed once we'll have other types of events)
      if (rawData.service && _AbstractEvent.AbstractEvent.SERVICES.indexOf(rawData.service) !== -1) {
        EventClass = _FrameworkEvent.FrameworkEvent;
      } else if (rawData.engine) {
        EventClass = _FrontendEvent.FrontendEvent;
      } else {
        throw new _UnknownRumEventException.UnknownRumEventException(rawData);
      }

      return new EventClass(kernel, rawData);
    }
  }]);

  return EventFactory;
}();


//////////////////
// WEBPACK FOOTER
// ../~/deep-log/lib.compiled/Driver/RUM/EventFactory.js
// module id = 405
// module chunks = 0